
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../components/base/Button';

export const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div>
  
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
              We are travelers, the destination world wide as a home to explore
            </h2>

            <p className="text-lg text-gray-600 mb-6 italic">
              "A vacation is what you take when you can no longer take what you've been taking."—Earl Wilson.
            </p>

            <p className="text-lg text-gray-700 mb-8">
              Experience the destinations world wide learn about people, art, culture, and history with Prime Meridian. We specialize in crafting personalized and bespoke holiday experience. With a keen eye for detail and a passion for authenticity, we design itineraries that resonate with your interests and preferences.
            </p>

            <Link to="/about" aria-label="About Us — about us">
              <Button variant="primary" size="lg">
                <i className="ri-book-open-line w-5 h-5 flex items-center justify-center"></i>
                About Us
              </Button>
            </Link>
          </div>

          {/* Image */}
          <div className="relative">
            <img
              src="/images/about section(1).png"
              alt="Scenic mountain landscape"
              className="w-full h-96 object-cover rounded-2xl shadow-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
